if (!window.Eurus.loadedScript.has('product-cart.js')) {
  window.Eurus.loadedScript.add('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
        engravingVariantId,
        laserArtworkFeeVariantId,
      ) => ({
        loading: false,
        added: false,
        errorMessage: false,
        mainHasError: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        insuranceVariantId: '',
        mixedFulfillmentNoticeActive: false,
        mixedFulfillmentBlocked: false,
        mixedFulfillmentBody: '',
        currentFulfillmentGroup: '',
        init() {
          this.injectMixedFulfillmentStyles();
          const groupInput = this.$el.querySelector('input[name="properties[_fulfillment_group]"]');
          this.currentFulfillmentGroup = groupInput ? String(groupInput.value || '').trim() : '';
          if (!this.currentFulfillmentGroup) return;
          // Evaluate on load, then keep in sync whenever the cart changes so the
          // notice stays pinned for exactly as long as the conflict exists.
          this.refreshMixedFulfillmentGuard();
          this._mixedFulfillmentHandler = () => this.refreshMixedFulfillmentGuard();
          document.addEventListener('eurus:cart:items-changed', this._mixedFulfillmentHandler);
          document.addEventListener('eurus:cart:add', this._mixedFulfillmentHandler);
        },
        loadInsurance(id) {
          if (this.insuranceVariantId == '') {
            this.insuranceVariantId = id;
          }
        },
        async getCartFulfillmentGroups() {
          try {
            const response = await fetch(`${Shopify.routes.root}cart.js`, {
              headers: { Accept: 'application/json' }
            });
            const cart = await response.json();

            const groups = new Set();
            const itemsWithoutGroup = [];
            (cart.items || []).forEach((item) => {
              const group = item.properties?._fulfillment_group || item.properties?.['_fulfillment_group'];
              if (group === 'ready-to-ship' || group === 'handcrafted-to-order') {
                groups.add(group);
              } else if (item.handle) {
                itemsWithoutGroup.push(item.handle);
              }
            });

            if (itemsWithoutGroup.length) {
              const uniqueHandles = [...new Set(itemsWithoutGroup)];
              await Promise.all(uniqueHandles.map(async (handle) => {
                try {
                  const productResponse = await fetch(`${Shopify.routes.root}products/${handle}.js`, {
                    headers: { Accept: 'application/json' }
                  });
                  if (!productResponse.ok) return;
                  const product = await productResponse.json();
                  const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
                  tags.forEach((tag) => {
                    const normalizedTag = String(tag).trim().toLowerCase();
                    if (normalizedTag === 'ready-to-ship') groups.add('ready-to-ship');
                    if (normalizedTag === 'handcrafted-to-order' || normalizedTag === 'drop-zone') groups.add('handcrafted-to-order');
                  });
                } catch (error) {
                  console.error('Error:', error);
                }
              }));
            }

            return groups;
          } catch (error) {
            console.error('Error:', error);
            return new Set();
          }
        },
        async refreshMixedFulfillmentGuard() {
          if (!this.currentFulfillmentGroup) { this.mixedFulfillmentBlocked = false; return; }
          const cartGroups = await this.getCartFulfillmentGroups();
          const blocked = this.hasMixedFulfillmentConflict(cartGroups, this.currentFulfillmentGroup);
          if (blocked) this.setMixedFulfillmentCopy();
          this.mixedFulfillmentBlocked = blocked;
        },
        setMixedFulfillmentCopy() {
          if (this.currentFulfillmentGroup === 'handcrafted-to-order') {
            this.mixedFulfillmentBody = 'This piece is <b>handcrafted to order in Türkiye</b>, while your cart holds ready-to-ship stock from the U.S. Different rates and timelines, so they’re ordered one at a time.';
          } else {
            this.mixedFulfillmentBody = 'This piece is <b>ready-to-ship stock from the U.S.</b>, while your cart holds a handcrafted-to-order item from Türkiye. Different rates and timelines, so they’re ordered one at a time.';
          }
        },
        async _clearMixedFulfillmentCart() {
          window.updatingCart = true;
          try {
            await fetch(`${Shopify.routes.root}cart/clear.js`, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (Alpine.store('xCartHelper')) {
              await Alpine.store('xCartHelper').reRenderSections();
              Alpine.store('xCartHelper').currentItemCount = 0;
            }
            if (Alpine.store('xCartNoti')) {
              Alpine.store('xCartNoti').applyCart({
                items: [],
                item_count: 0,
                total_price: 0,
                currency: Shopify.currency?.active || Alpine.store('xCartNoti').currency
              });
              Alpine.store('xCartNoti').removedNotice = null;
            }
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          } catch (error) {
            console.error('Error:', error);
          } finally {
            window.updatingCart = false;
          }
        },
        async clearCartAndAdd() {
          if (this.loading) return;
          this.loading = true;
          await this._clearMixedFulfillmentCart();
          // Conflict is gone now that the cart is empty — release the guard so the
          // button and dynamic checkout re-enable before we re-add this item.
          this.mixedFulfillmentBlocked = false;
          this.loading = false;
          this.fireMixedFulfillmentToast('Cart cleared · adding your item');
          this.$nextTick(() => {
            const btn = this.$el.querySelector('button[name="add"]:not([disabled])');
            if (btn) btn.click();
          });
        },
        fireMixedFulfillmentToast(message) {
          let toast = document.getElementById('x-mf-toast');
          if (!toast) {
            toast = document.createElement('div');
            toast.id = 'x-mf-toast';
            toast.setAttribute('role', 'status');
            document.body.appendChild(toast);
          }
          toast.textContent = '✓ ' + message;
          requestAnimationFrame(() => toast.classList.add('x-mf-toast-show'));
          clearTimeout(window.__xMfToastTimer);
          window.__xMfToastTimer = setTimeout(() => {
            toast.classList.remove('x-mf-toast-show');
          }, 2600);
        },
        injectMixedFulfillmentStyles() {
          if (document.getElementById('x-mf-styles')) return;
          const style = document.createElement('style');
          style.id = 'x-mf-styles';
          style.textContent = '.x-mf-blocked{opacity:.6!important;cursor:not-allowed!important;pointer-events:none!important;}' +
            '#x-mf-toast{position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(12px);background:#3b1d11;color:#f5f1eb;font-weight:600;font-size:13.5px;line-height:1.3;padding:14px 22px;border-radius:12px;box-shadow:0 16px 40px -18px rgba(0,0,0,.6);z-index:9999;opacity:0;pointer-events:none;transition:opacity .25s ease,transform .25s ease;max-width:calc(100vw - 40px);text-align:center;}' +
            '#x-mf-toast.x-mf-toast-show{opacity:1;transform:translateX(-50%) translateY(0);}';
          document.head.appendChild(style);
        },
        hasMixedFulfillmentConflict(cartGroups, incomingGroup) {
          if (!incomingGroup) return false;
          return (incomingGroup === 'ready-to-ship' && cartGroups.has('handcrafted-to-order')) ||
            (incomingGroup === 'handcrafted-to-order' && cartGroups.has('ready-to-ship'));
        },
        scrollToAtcBtn(btnId) {
          const originalAtcBtn = document.querySelector(`#${btnId}`);
          originalAtcBtn.scrollIntoView({
            behavior: "smooth",
            block: 'center',
            inline: 'center'
          })
        },
        async addToCart(e, required, quickView, sticky) {
          this.loading = true;         
          e.preventDefault();

          setTimeout(async () => {
            if (required) {
              var productInfo = this.$el.closest('.product-info');
              if(sticky){
                productInfo = document.querySelector('.product-info');
              }
              if (productInfo) {
                var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
                this.stopAction = false;
                let scrollStatus = false;
                
                propertiesInput.length && propertiesInput.forEach((input) => {
                  if (input.required && input.value.trim() == '' || input.classList.contains("validate-checkbox")) {
                    input.classList.add("required-picker");
                    this.stopAction = true;
                    if(!scrollStatus){
                      input.parentElement.querySelector('.text-required').scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                      });
                      scrollStatus = true;
                    }    
                  } else {
                    input.classList.remove("required-picker");
                  }                
                });              
              }
              if (this.stopAction) {
                setTimeout (() => {
                  this.loading = false;
                }, 500);
                return true;
              }
            }
            await Alpine.store('xCartHelper').waitForCartUpdate();
            window.updatingCart = true;

            var productForm = this.$el.closest('.product-info') || this.$el.closest('form');
            const engravingText = this.$refs.engraving_text || productForm?.querySelector('[data-engraving-text]');
            const engravingName = this.$refs.text_area_name || productForm?.querySelector('[data-engraving-name]');
            const engravingActive = productForm?.querySelector('[data-engraving-active]');
            const laserArtworkFeeActive = productForm?.querySelector('[data-laser-artwork-fee-active]');

            if (engravingText && engravingVariantId) {
              if (engravingText.value.trim()) {
                if (!engravingText.hasAttribute('name') && engravingName?.value) engravingText.setAttribute('name', engravingName.value);
              } else {
                if (engravingText.hasAttribute('name')) engravingText.removeAttribute('name');
              }
            }

            let formData = new FormData(this.$refs.product_form);
            const productId = formData.get('product-id');
            var edt_element = productForm ? productForm.querySelector(`.hidden.cart-edt-properties-${productId}`) : null;
            if (edt_element) {
              edt_element.value = edt_element.value.replace("time_to_cut_off", Alpine.store('xEstimateDelivery').noti)
            }
            formData = new FormData(this.$refs.product_form);

            formData.append(
              'sections',
              Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            const newFormData = new FormData();
            for (let [key, value] of formData.entries()) {
              if (value instanceof File && value.name === '' && value.size === 0) continue;
              if (value !== '') {
                newFormData.append(key, value);
              }
            }

            const match = document.cookie.match('(^|;)\\s*' + 'eurus_insurance' + '\\s*=\\s*([^;]+)');
            const linkedProductList = newFormData.getAll('properties[_linked_product_id][]');
            const linkedProductListQty = newFormData.getAll('properties[_linked_product_id_qty][]');
            const hasEngravingSelection = engravingVariantId && engravingActive?.value === 'true';
            const hasLaserArtworkFeeSelection = laserArtworkFeeVariantId && laserArtworkFeeActive?.value === 'true';
            const incomingFulfillmentGroup = newFormData.get('properties[_fulfillment_group]');
            const cartFulfillmentGroups = await this.getCartFulfillmentGroups();
            if (this.hasMixedFulfillmentConflict(cartFulfillmentGroups, incomingFulfillmentGroup)) {
              // Safety net: if the button was somehow triggered while a conflict
              // exists, pin the persistent notice and abort the add.
              this.setMixedFulfillmentCopy();
              this.mixedFulfillmentBlocked = true;
              window.updatingCart = false;
              this.loading = false;
              return true;
            }
            if (
              (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) || 
              hasEngravingSelection || 
              hasLaserArtworkFeeSelection || 
              (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) || 
              (linkedProductList.length > 0) ||
              (linkedProductListQty.length > 0)
            ) {
              const variantId = formData.get('id');
              const productTitle = productForm ? productForm.querySelector(`.product-variant-title-${formData.get('product-id')}-${variantId}`)?.textContent : null
              let additionalOptionData = [];
              if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
                additionalOptionData.push(
                  {
                    id: wrappringVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (linkedProductListQty.length > 0) {
                let qty = newFormData.get('quantity');
                linkedProductListQty.forEach(val => {
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: qty,
                      parent_id: variantId,
                      properties: {
                        "For": productTitle
                      }
                    }
                  );
                });
              }
              if (linkedProductList.length > 0) {
                linkedProductList.forEach(val => {
                  const colorChangeFeeInput = productForm?.querySelector(`[data-color-change-fee][value="${val}"]:not(:disabled)`);
                  const linkedProductProperties = {
                    "For": productTitle
                  };
                  if (colorChangeFeeInput?.dataset.colorChangeFeeLabel) {
                    linkedProductProperties._color_change_fee = colorChangeFeeInput.dataset.colorChangeFeeLabel;
                  }
                  additionalOptionData.push(
                    {
                      id: val,
                      quantity: 1,
                      parent_id: variantId,
                      properties: linkedProductProperties
                    }
                  );
                });
              }
              
              if (hasEngravingSelection) {
                additionalOptionData.push(
                  {
                    id: engravingVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (hasLaserArtworkFeeSelection) {
                additionalOptionData.push(
                  {
                    id: laserArtworkFeeVariantId,
                    quantity: 1,
                    parent_id: variantId,
                    properties: {
                      "For": productTitle
                    }
                  }
                );
              }
              if (this.insuranceVariantId && !localStorage.getItem('insuranceRemoved') && (!match || match[1].trim() === '')) {
                additionalOptionData.push(
                  {
                    id: this.insuranceVariantId,
                    quantity: 1
                  }
                );
              }
              if (additionalOptionData.length !== 0) {
                additionalOptionData.forEach((item, index) => {
                  const base = `items[${index}]`;

                  newFormData.append(`${base}[id]`, item.id);
                  newFormData.append(`${base}[quantity]`, item.quantity);

                  if (item.parent_id) {
                    newFormData.append(`${base}[parent_id]`, item.parent_id);
                  }

                  if (item.properties) {
                    Object.entries(item.properties).forEach(([key, value]) => {
                      newFormData.append(`${base}[properties][${key}]`, value);
                    })
                  }
                })
              }
            }

            let resProductId;

            await fetch(`${Eurus.cart_add_url}`, {
              method:'POST',
              headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
              body: newFormData
            }).then(reponse => {
              return reponse.json();
            }).then(async (response) => {
              if (response.status == '422') {
                if (typeof response.errors == 'object') {
                  this.error_message_wrapper = response.errors;
                  document.querySelector('.recipient-error-message').classList.remove('hidden');
                } else {
                  this.errorMessage = true;
                  setTimeout(() => {
                    this.errorMessage = false;
                  }, 3000);
                  if(this.$refs.error_message){
                    this.$refs.error_message.textContent = response.description;
                  }
                  if(this.$refs.error_message_mobile){
                    this.$refs.error_message_mobile.textContent = response.description;
                  }
                }
                if (Alpine.store('xMiniCart')) {
                  Alpine.store('xMiniCart').reLoad();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
              } else {  
                resProductId = response.product_id;

                if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                  Alpine.store('xCartNoti').setItem(response); 
                }
                this.added = true;
                setTimeout(() => {
                  this.added = false;
                }, 1600);
                document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
                this.error_message_wrapper = {};
      
                if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                  Alpine.store('xQuickView').show = false;
                }
                Alpine.store('xPopup').close();
                document.dispatchEvent(new CustomEvent("eurus:video-popup:close-popup"));
                if((quickView && Alpine.store('xQuickView').buttonQuickView && Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                  document.dispatchEvent(new CustomEvent("eurus:cart:add-as-bundle"));
                } else {
                  Alpine.store('xCartHelper').reRenderSections(response.sections);
                  if (!Alpine.store('xCartNoti') || !Alpine.store('xCartNoti').enable) {
                    // "stamp & fly" animation (tl-cart-fly.js) lands on the cart icon, then opens the drawer
                    if (window.tlFlyToCart) {
                      window.tlFlyToCart(this.$el, () => Alpine.store('xMiniCart').openCart());
                    } else {
                      Alpine.store('xMiniCart').openCart();
                    }
                  }
                  Alpine.store('xCartHelper').currentItemCount = parseInt(document.getElementById('cart-icon-bubble').innerHTML);
                  if (Alpine.store('xQuickView')) {
                    Alpine.store('xQuickView').openPopupMobile = false;
                  }
                  this.$el.closest('.choose-options')?.getElementsByClassName('js-close-button')[0].click();
                  this.$el.closest('.js-product-container')?.getElementsByClassName('js-close-button')[0].click();
                  document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
                }
              }
            }).catch((error) => {
              console.error('Error:', error);
            }).finally(() => {
              window.updatingCart = false;
              document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${resProductId}`));
              this.loading = false;
              if ((quickView && Alpine.store('xQuickView').buttonQuickView && !Alpine.store('xQuickView').buttonQuickView.dataset.addAsBundle) || (!quickView && this.$refs.product_form && !this.$refs.product_form.querySelector('[data-add-as-bundle="true"]'))) {
                if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
              }
              document.cookie = `eurus_insurance=${this.insuranceVariantId}; path=/`;  
            })
          }, 0)
        }
      }))
    });
  });
}
